import {
  BrowserRouter,
  Routes as ReactRouterRoutes,
  Route,
} from 'react-router-dom';

import {
  ROUTE_TAG_FEATURES,
  ROUTE_TAG_APP_PAGES,
} from 'hb-react/publicoffice/constants/routeTags';
import PublicOfficeApp from 'hb-react/publicoffice/providers/App';
import useNetworkConfiguration from 'hb-react/publicoffice/utils/useNetworkConfiguration';
import DonationsApp from 'hb-react/shared/apps/Donations/DonationsApp';
import DonationContext, {
  defaultValue as defaultValueDonationContext,
} from 'hb-react/shared/contexts/DonationContext';

const DonationsAppStandalone = ({
  page,
  page_title: pageTitle,
  network_title: networkTitle,
}) => {
  const { networkConfiguration } = useNetworkConfiguration({
    networkConfigurationOptions: ['stripe_sca'],
    networkRouteTags: [
      {
        routeTag: ROUTE_TAG_FEATURES,
        params: { app_names: ['donations'] },
      },
      {
        routeTag: ROUTE_TAG_APP_PAGES,
        params: { app_name: 'donations' },
      },
    ],
  });

  if (!networkConfiguration) {
    return null;
  }

  const {
    colors,
    styles,
    theming,
    networkConfigData,
    featuresData,
    appPagesData,
  } = networkConfiguration;

  const {
    features: {
      donations: { config, extraData },
    },
  } = featuresData;
  const { categories, title } = extraData;

  const customNetwork = {
    app_pages: [appPagesData],
    features: { donations: { config } },
    network_configuration: networkConfigData,
    colors: colors.colors,
    styles: styles.styles,
    theming: theming?.theming,
    title: networkTitle ?? title,
  };

  const customOtherProps = { categories, pageTitle };
  const isWhitelabeled = !!defaultValueDonationContext.whitelabelURL;

  return (
    <PublicOfficeApp
      network={customNetwork}
      providers={[
        {
          provider: DonationContext.Provider,
          value: {
            whitelabelURL: isWhitelabeled,
          },
        },
      ]}
    >
      <BrowserRouter>
        <ReactRouterRoutes>
          <Route
            path={isWhitelabeled ? '/*' : '/donations/*'}
            element={<DonationsApp {...customOtherProps} configPage={page} />}
          />
        </ReactRouterRoutes>
      </BrowserRouter>
    </PublicOfficeApp>
  );
};

export default DonationsAppStandalone;
